import { Component, OnInit } from '@angular/core';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { PrintService } from 'src/app/core/services/print.service';
import { Client } from 'src/app/shared/models/clients/client';
import { Opponent } from 'src/app/shared/models/data/opponent';
import { CaseSession } from 'src/app/shared/models/hearings/caseSession';

@Component({
  selector: 'app-print-case-sessions',
  templateUrl: './print-case-sessions.component.html',
  styleUrls: ['./print-case-sessions.component.scss']
})
export class PrintCaseSessionsComponent implements OnInit {
  sessions: CaseSession[] = [];
  clients: Client[];
  opponents: Opponent[];
  fileNum: string;
  claimNumbers = [];


  constructor(
    private printService: PrintService,
  ) {
    this.sessions = this.printService.data.sessions;
    this.clients = this.printService.data.fileInfo.clients;
    this.opponents = this.printService.data.fileInfo.opponents;
    this.fileNum = this.printService.data.fileInfo.fileNum;
    this.claimNumbers = this.printService.data.fileInfo.claimNumbers;
  }

  ngOnInit(): void {
    this.printService.onDataReady('Court Hearings');
  }

}
